// DS: i4.41
import React, { useId } from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Attribution: React.FC<Props> = props => {
  const uniqueId = useId();
  return (
    <IconWrap {...props}>
      <svg
        width="16"
        height="16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath={`url(#i441-${uniqueId})`}>
          <path
            d="M7.986 0c2.247 0 4.142.771 5.685 2.314C15.223 3.867 16 5.762 16 8c0 2.248-.762 4.119-2.286 5.614C12.094 15.204 10.185 16 7.986 16c-2.162 0-4.038-.786-5.629-2.357C.786 12.07 0 10.19 0 8s.786-4.085 2.357-5.686C3.9.771 5.776 0 7.986 0Zm.028 1.443c-1.819 0-3.357.638-4.614 1.914C2.095 4.691 1.443 6.238 1.443 8c0 1.772.647 3.305 1.942 4.6 1.296 1.295 2.838 1.943 4.629 1.943 1.78 0 3.333-.652 4.657-1.957 1.257-1.21 1.886-2.739 1.886-4.586 0-1.82-.639-3.367-1.914-4.643-1.276-1.276-2.82-1.914-4.629-1.914Zm2.143 4.571v3.272h-.914v3.885H6.757V9.286h-.914V6.014c0-.143.05-.264.15-.364.1-.1.222-.15.364-.15h3.286c.133 0 .253.05.357.15.104.1.157.221.157.364ZM6.886 3.957c0-.752.37-1.128 1.114-1.128.743 0 1.114.376 1.114 1.128 0 .743-.371 1.115-1.114 1.115-.743 0-1.114-.372-1.114-1.115Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id={`i441-${uniqueId}`}>
            <path fill="currentColor" d="M0 0h16v16H0z" />
          </clipPath>
        </defs>
      </svg>
    </IconWrap>
  );
};
Attribution.displayName = 'Attribution';

export default Attribution;
